<div cdkDropListGroup class="example-boundary">

	<div class="wrapper">
		<!-- Sidebar -->
		<nav id="sidebar" [style.right.px]="right" class="rounded-10">
			<div cdkDropList #inactiveList="cdkDropList" [cdkDropListData]="inactive"
				[cdkDropListConnectedTo]="[activeList]" (cdkDropListDropped)="drop($event)">
				<ul style="list-style-type:none; max-height: 500px; overflow-x: hidden; ">
					<li cdkDrag (cdkDragStarted)="dragStart($event)" (cdkDragEnded)="dragEnd($event)" *ngFor="let item of inactive">
						<div class="d-flex align-items-center bg-light rounded-10">
							<div class="fondpic">
								<i [ngClass]="getType(item)?'fa fa-sort-numeric-desc':'fa fa-line-chart'" ></i>
							</div>
							<div >
								<p class="card-header">{{item}}</p><img [src]="getSource(item)">
							</div>
						</div>
					</li>

				</ul>

			</div>
		</nav>

	</div>

	<div (mouseup)='placeGraph($event)' (mouseover)='intoDrop($event)' (mouseout)="outDrop($event)" class="container-fluid d-flex example-boundary" cdkDropList
    #activeList="cdkDropList"
    [cdkDropListData]="active"
    [cdkDropListConnectedTo]="[inactiveList]"
	class="example-list"
	(cdkDropListDropped)="drop($event)" style="width: 100%;
	height: 100vh ; position: absolute;  border: dashed rgb(150, 150, 150); color: transparent;" 
	[@dragDrop]="droppable && dragging ? 'on' : 'out'"
	[hidden]="setGraph != 'show'">
	
	</div>
</div>
<div class="container-fluid d-flex example-boundary vh-100">
	<div #main mySpy>
	</div>
	<test-graph *ngFor="let item of active" graph="{{item}}" [setting]='setting' [date_start]='date_start' [date_end]='date_end' page="Profil" [compteur]='compteur'></test-graph>
</div>	

